import { Box, Typography } from '@mui/material';
import { DisplayOptions, Sentence } from '../../mockLessonContent';
import { INTER, NAVY, POPPINS, SLATE } from '../../studentStyles';
import InfoExpander from './InfoExpander';

export interface OptionalContent {
    infoText?: string;
    definition?: string;
    example?: Sentence;
}

// Optional teaching material is independent of the task's required prompt/answer.
export default function OptionalSupport({ content, display }: { content: OptionalContent; display?: DisplayOptions }) {
    return <Box>
        {display?.info !== false && content.infoText && <InfoExpander text={content.infoText} />}
        {display?.definition && content.definition && <InfoExpander label="Definition" text={content.definition} />}
        {display?.example && content.example && <Box sx={{ mt: 1.5 }}>
            <Typography sx={{ fontFamily: INTER, fontSize: 11, color: SLATE }}>EXAMPLE</Typography>
            <Typography sx={{ fontFamily: POPPINS, fontSize: 18, color: NAVY }}>{content.example.hanzi}</Typography>
            {display.pinyin && <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE }}>{content.example.pinyin}</Typography>}
            {display.english && <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE }}>{content.example.english}</Typography>}
        </Box>}
    </Box>;
}
